export default __webpack_public_path__ + "stroke-width-5.asset.d3c64db1905ee7aba329489a21a22a9d.svg";